import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';

const { spacing, colors, typography } = THEME;

export const styles = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.sm,
	},
	collapsibleHeader: {
		display: 'flex',
		alignItems: 'center',
		gap: spacing.sm,
		padding: `${spacing.sm}px ${spacing.md}px`,
		backgroundColor: colors.background.light,
		border: `1px solid ${colors.border.main}`,
		borderRadius: 4,
		cursor: 'pointer',
		userSelect: 'none',
		width: '100%',
		textAlign: 'left',
		':hover': {
			backgroundColor: colors.background.main,
		},
	},
	collapsibleIcon: {
		transition: 'transform 150ms ease-out',
		fontSize: 12,
	},
	collapsibleIconOpen: {
		transform: 'rotate(90deg)',
	},
	collapsibleTitle: {
		flex: 1,
		fontSize: typography.fontSizes.sm,
		fontWeight: 600,
		color: colors.text.main,
	},
	collapsibleCount: {
		fontSize: typography.fontSizes.xs,
		color: colors.text.light,
		backgroundColor: colors.background.main,
		padding: '2px 8px',
		borderRadius: 10,
	},
	collapsibleContent: {
		padding: spacing.md,
		border: `1px solid ${colors.border.main}`,
		borderTop: 'none',
		borderRadius: '0 0 4px 4px',
		marginTop: -4,
	},
	// Variable list styles
	variablesList: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.xs,
	},
	variableItem: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		padding: spacing.sm,
		backgroundColor: colors.background.light,
		borderRadius: 4,
		border: `1px solid ${colors.border.main}`,
	},
	variableInfo: {
		display: 'flex',
		flexDirection: 'column',
		gap: 2,
		flex: 1,
		minWidth: 0,
	},
	variableActions: {
		display: 'flex',
		gap: spacing.xs,
	},
	variableKey: {
		fontSize: typography.fontSizes.sm,
		fontWeight: 600,
		color: colors.primary.main,
		fontFamily: 'monospace',
	},
	variableValue: {
		fontSize: typography.fontSizes.sm,
		color: colors.text.main,
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
	emptyValue: {
		color: colors.text.light,
		fontStyle: 'italic',
	},
	emptyState: {
		color: colors.text.light,
		fontSize: typography.fontSizes.sm,
		fontStyle: 'italic',
		padding: spacing.md,
		textAlign: 'center',
	},
	actionsRow: {
		display: 'flex',
		gap: spacing.sm,
		marginTop: spacing.md,
	},
	undefinedVariables: {
		marginTop: spacing.sm,
		padding: spacing.sm,
		backgroundColor: '#fff8e1',
		borderRadius: 4,
		fontSize: typography.fontSizes.sm,
	},
	undefinedVariablesLabel: {
		color: colors.text.main,
		marginBottom: spacing.xs,
	},
	undefinedVariableChip: {
		display: 'inline-flex',
		alignItems: 'center',
		gap: 4,
		background: '#ffe0b2',
		border: 'none',
		padding: '4px 8px',
		borderRadius: 4,
		cursor: 'pointer',
		fontSize: typography.fontSizes.xs,
		marginRight: spacing.xs,
		marginBottom: spacing.xs,
		':hover': {
			background: '#ffcc80',
		},
	},
	// Modal styles
	editModal: {
		maxWidth: 700,
		width: '90%',
	},
	modalField: {
		marginBottom: spacing.md,
	},
	modalLabel: {
		display: 'block',
		fontSize: typography.fontSizes.sm,
		fontWeight: 600,
		color: colors.text.main,
		marginBottom: spacing.xs,
	},
	modalTextArea: {
		width: '100%',
		minHeight: 400,
		resize: 'vertical',
	},
	modalError: {
		color: colors.danger.main,
		fontSize: typography.fontSizes.xs,
		marginTop: spacing.xs,
	},
	previewModal: {
		maxWidth: 800,
		width: '90%',
	},
	// Preview modal styles
	previewModalContent: {
		maxHeight: '60vh',
		overflowY: 'auto',
	},
	previewPromptContent: {
		whiteSpace: 'pre-wrap',
		fontFamily: 'monospace',
		fontSize: typography.fontSizes.sm,
		lineHeight: 1.6,
		padding: spacing.md,
		backgroundColor: colors.background.light,
		borderRadius: 4,
		border: `1px solid ${colors.border.main}`,
	},
	highlightedVariable: {
		backgroundColor: '#e3f2fd',
		padding: '2px 4px',
		borderRadius: 2,
		fontWeight: 500,
	},
	undefinedVariable: {
		backgroundColor: '#fff3e0',
		padding: '2px 4px',
		borderRadius: 2,
		fontStyle: 'italic',
	},
});
